export default __webpack_public_path__ + "images/Asteroid.1-e759047327f7c956dc252b549250cfd6.png";